
(() => {
  if (window.rbCardAlignment) return;
  window.rbCardAlignment = true;
  const slots = ['vendor', 'title', 'details', 'reviews', 'top-price', 'swatches', 'inventory', 'bottom-price'];
  let frame;
  // Speed: all reads are done before any writes (no layout thrashing), and DOM mutations
  // outside product cards (apps, chat widgets, etc.) no longer trigger a re-align.
  const align = () => {
    frame = null;
    const cards = [...document.querySelectorAll('product-card')].filter(card => card.querySelector('.rb-card-row') && card.getClientRects().length);
    if (!cards.length) return;
    cards.forEach(card => card.querySelectorAll('.rb-card-row').forEach(row => { row.style.minHeight = ''; }));
    const groups = new Map();
    cards.forEach(card => {
      const parent = card.parentElement;
      const container = parent.tagName === 'LI' ? parent.parentElement : parent;
      if (!groups.has(container)) groups.set(container, []);
      const rows = groups.get(container);
      const top = card.getBoundingClientRect().top;
      let row = rows.find(group => Math.abs(group.top - top) < 3);
      if (!row) { row = { top, cards: [] }; rows.push(row); }
      row.cards.push(card);
    });
    const writes = [];
    groups.forEach(rows => rows.forEach(group => {
      if (group.cards.length < 2) return;
      slots.forEach(slot => {
        const cells = group.cards.map(card => card.querySelector('.rb-card-row--' + slot)).filter(Boolean);
        if (cells.length < 2) return;
        const height = Math.max(...cells.map(cell => cell.getBoundingClientRect().height));
        writes.push([cells, height]);
      });
    }));
    writes.forEach(([cells, height]) => cells.forEach(cell => { cell.style.minHeight = height + 'px'; }));
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(align); };
  const touchesCards = mutation => {
    const target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
    if (target && target.closest && target.closest('product-card')) return true;
    return [...mutation.addedNodes].some(node => node.nodeType === 1 &&
      (node.matches('product-card') || (node.querySelector && node.querySelector('product-card'))));
  };
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(list => { if (list.some(touchesCards)) schedule(); })
    .observe(document.body, { childList: true, subtree: true, characterData: true });
  document.fonts.ready.then(schedule);
  schedule();
})();
